// extracted by mini-css-extract-plugin
export default {"Course":"Course_Course__7FQ76","Course__ExercisesList":"Course_Course__ExercisesList__uaqoA"};